// Locale-dependent formatting for the whole GM HUD — dates, times and amounts — in one place.
// Every page formats through these named helpers instead of calling toLocale*String with its
// own locale and options, so switching locale (or making it per-user) is a change here only.

export const LOCALE = "da-DK";

// The named formats in use. Adjust a format here and every caller follows.
const FORMATS = {
    time: { hour: "2-digit", minute: "2-digit" },                                  // 14:05
    timestamp: {                                                                    // 22.09.2026, 14.05.09
        day: "2-digit", month: "2-digit", year: "numeric",
        hour: "2-digit", minute: "2-digit", second: "2-digit",
    },
    date: { day: "numeric", month: "short" },                                       // 22. sep.
    dateWithYear: { day: "numeric", month: "short", year: "numeric" },              // 22. sep. 2026
    weekday: { weekday: "short" },                                                  // tir.
    weekdayDate: { weekday: "short", day: "numeric", month: "short" },              // tir. 22. sep.
    longDate: { weekday: "long", day: "numeric", month: "long" },                   // tirsdag 22. september
};

// toDate accepts what the app passes around: a Date, Unix milliseconds, an ISO timestamp, or a
// plain "YYYY-MM-DD" day. A plain day is read as local noon, so it never slips into the
// neighbouring day when the browser is not on Danish time.
export function toDate(value) {
    if (value instanceof Date) return value;
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(`${value}T12:00:00`);
    return new Date(value);
}

const dateFormatter = name => value => toDate(value).toLocaleDateString(LOCALE, FORMATS[name]);

export const formatTime = value => toDate(value).toLocaleTimeString(LOCALE, FORMATS.time);
export const formatTimestamp = value => toDate(value).toLocaleString(LOCALE, FORMATS.timestamp);
export const formatDate = dateFormatter("date");
export const formatDateWithYear = dateFormatter("dateWithYear");
export const formatWeekday = dateFormatter("weekday");
export const formatWeekdayDate = dateFormatter("weekdayDate");
export const formatLongDate = dateFormatter("longDate");

// Short weekday names Monday..Sunday in the app locale ("man.", "tir.", …), taken from the
// formatter itself so they can't drift from it. 2024-01-01 is a Monday.
export const WEEKDAY_NAMES = Array.from({ length: 7 }, (_, i) => formatWeekday(new Date(2024, 0, 1 + i)));

export function formatNumber(value, options = {}) {
    return Number(value).toLocaleString(LOCALE, options);
}

export function formatKr(amount) {
    return `${formatNumber(amount, { maximumFractionDigits: 2 })} kr.`;
}
